export const RECIPIENT_VALIDATION_ALERT = 'validation_alert.message';
